import { isNotEmpty } from '../utils';

export enum Service {
  GET_LOCALIZATIONS = 'getLocalizations',
  GET_PRICES_FOR_FULL_YEAR = 'getPricesForFullYear',
  GET_PRICES_FOR_FOLLOWING_MONTH = 'getPricesForFollowingMonth',
  LOCATION_SEARCH = 'locationSearch',
  GET_LOCATION_BY_LAT_LONG = 'getLocationByLatLong',
  GET_SUGGESTED_LOCATIONS = 'getSuggestedLocations',
  GET_TRENDING_LOCATIONS = 'getTrendingLocations',
  GET_LOCATIONS = 'getLocations',
  GET_ROUTE_CFFS = 'getRouteCffs',
  GET_FLIGHT_AVAILABILITY = 'getFlightAvailability',
  GET_TIMEGEO = 'getTimeGeo',
  GET_AIR_CALENDAR = 'getAirCalendar',
  GET_PROMO_CODE_TERMS = 'getPromoCodeTerms',
}

export enum Status {
  OK = 'ok',
  CANCELED = 'canceled',
  ERROR = 'error',
}
export interface Response<T> {
  status: Status;
  payload?: T;
}

export class Lock {
  private cancelFunctions: (() => void)[] = [];

  join(cancelFunction: () => void): void {
    this.cancelFunctions.push(cancelFunction);
  }

  release(): void {
    this.cancelFunctions = [];
  }

  isLocked(): boolean {
    return isNotEmpty(this.cancelFunctions);
  }

  cancel(): boolean {
    const wasLocked = this.isLocked();
    if (wasLocked) {
      this.cancelFunctions.forEach((token: () => void) => token());
      this.cancelFunctions = [];
    }
    return wasLocked;
  }
}

export type CastResponse<TContent> = (e: Response<any>) => Response<TContent>;
export const castResponse = <TContent>(e: Response<any>): Response<TContent> => e as any as Response<TContent>;
